import { render, staticRenderFns } from "./ShProductDetail.vue?vue&type=template&id=0729e960&scoped=true&"
import script from "./ShProductDetail.vue?vue&type=script&lang=js&"
export * from "./ShProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShProductDetail.vue?vue&type=style&index=0&id=0729e960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729e960",
  null
  
)

export default component.exports